









import { Vue, Component, Prop } from 'vue-property-decorator';
import ITab from './ITab';
import urlHelperService from '@/core/urlHelper.service';

@Component({
    name: 'Tab'
})
export default class Tab extends Vue implements ITab {
    @Prop({ type: String, required: true }) name!: string;
    @Prop({ type: String }) hash!: string;
    @Prop({ type: Boolean, default: false }) selected!: boolean;
    @Prop({ type: Boolean, default: false }) keepAlive!: boolean;

    active: boolean = this.selected;

    toggle(active: boolean) {
        this.active = active;

        if (active && this.hash) {
            if (urlHelperService.getHash() !== this.hash) {
                urlHelperService.setHash(this.hash);
            }
        }
    }

    get isActive() {
        return this.active;
    }
}
